import { createContext } from "react";

const context = createContext({});

export default context;
